import { render, staticRenderFns } from "./AffectedWholesalersDialog.vue?vue&type=template&id=4028f49c&scoped=true&"
import script from "./AffectedWholesalersDialog.vue?vue&type=script&lang=js&"
export * from "./AffectedWholesalersDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4028f49c",
  null
  
)

export default component.exports